import * as React from "react";
import { connect, Provider } from "react-redux";
import Moment from "moment";
import { LocationWorkflowStepName } from "./config";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  ModalBody,
  ProgressBar,
  Row
} from "react-bootstrap";
import { UserInfo } from "../../../Login/common/defaults";
import { eLocationQueue } from "../controller/LocationQueueController";
import Api from "../../../../services/Api";
import { ApiResponse } from "apisauce";
import { DateRangePicker } from "react-dates";
import { getTableValuesByGroupName } from "../../../../services/Utils/IndexedDBUtils";
import { extendMoment } from "moment-range";
import * as urls from "../../../shared/urls";
import LocationEntry from "./LocationEntry";
import { eWorkflowQueues } from "../../common/types";
import { b64toBlob } from "../../../PrintPDF/common/utils";
import {
  IAppRouteLocation,
  IExportColumnMap,
  IFormioValidationError,
  IWorkflowItemStep,
  PagedResultsRequest
} from "../../../../common/sharedTypes";
import * as documentDownloadService from "../../../../services/documentDownloadService";
import { toast } from "react-toastify";
import { hasPermission } from "../../../Login/common/defaults";
import MergedIndicator from "../../common/MergedIndicator";
import { QueueStartDate } from "../../common";
import PagedDatatable from "../../../PagedDataTable";
import { TableColumn } from "react-data-table-component/dist/DataTable/types";
import {
  GetReportsByQueueTypePagedRequest,
  IGetReportsByQueueTypePagedResponse,
  ISpotMappingQueueDetails
} from "../business-objects/common";
import { IDataTableOptionalProps } from "../../../DataTable/common/defaults";
import LocalStorageUtils from "../../common/LocalStorageUtils";
import CompletedIndicator from "../../common/CompletedIndicator";
import DriverReportMergedIndicator from "../../common/DriverReportMergedIndicator";
import CommentsButton from "../../../Comments/CommentsButton";

import rootReducer from "../../../../store/Reducers";
import store from "../../../../store/Store";
const reduxStore = store({}, rootReducer);

const moment = extendMoment(Moment);

export interface ILocationQueuePagedProps {
  endPoint: string;
  currentUser: UserInfo;
  history: any;
  queueToShow: eLocationQueue;
  assignWorkflowItem: (
    url: string,
    stepItemId: number,
    assignToId: number
  ) => Promise<any>;
  updateHeaderOnNav: (headerInfo: string) => void;
  openWorkflowItemStep?: IWorkflowItemStep;
}

export interface ILocationQueuePagedState {
  data: ISpotMappingQueueDetails[];
  imageData: string;
  startDate: Moment.Moment;
  endDate: Moment.Moment;
  focusedInput: any;
  countyData: any[];
  showDataEntry: boolean;
  selectedItemId: number;
  formIsReadOnly: boolean;
  currentCrashId: any;
  imagePopup: boolean;
  workflowItemStepId: number;
  cellData: any;
  rowData: any;
  transcriberData: any[];
  jsonData: any[];
  workflowItemStepWorkflowItemId: number;
  enableContinue: boolean;
  showTValForm: boolean;
  includeNewDriverReports: boolean;
  showLRS: boolean;
  showLoadingNext: boolean;
  locationEntryDataToSave: any;
  locationEntryValidations: IFormioValidationError[];
  savingLocationData: boolean;
  selectedCounty: string;
  selectedRegion: number;
  loadingWorkflowSteps: boolean;
  totalWorkflowItemSteps: number;
  pagingCriteria: PagedResultsRequest;
}

enum Districts {
  All = 0,
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
  Six = 6
}

export default class LocationQueuePaged extends React.Component<
  ILocationQueuePagedProps,
  ILocationQueuePagedState
> {
  dataEntry: any;
  private lIncludeNewDriverReportsVariable: string =
    "LocationIncludeNewDriverReportsCheckbox";
  private lPendingLRSVariable: string = "LocationPendingLRSCheckbox";
  private lStartDateVariable: string = "LocationStartDate";
  private lEndDateVariable: string = "LocationEndDate";
  private lCountyVariable: string = "LocationCounty";
  private lRegionVariable: string = "LocationRegion";

  private smIncludeNewDriverReportsVariable: string =
    "SpotMappingIncludeNewDriverReportsCheckbox";
  private smPendingLRSVariable: string = "SpotMappingPendingLRSCheckbox";
  private smStartDateVariable: string = "SpotMappingStartDate";
  private smEndDateVariable: string = "SpotMappingEndDate";
  private smCountyVariable: string = "SpotMappingCounty";
  private smRegionVariable: string = "SpotMappingRegion";

  currentImageWindow: any;

  constructor(props: ILocationQueuePagedProps) {
    super(props);

    const persistentIncludeNewDriverReports =
      LocalStorageUtils.getLocalStorageBool(
        this.getIncludeNewDriverVariable()
      ) || false;
    const pendingLRSVariable =
      LocalStorageUtils.getLocalStorageBool(this.getPendingLRSVariable()) ||
      false;
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.getStartDateVariable()
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.getEndDateVariable()
    );

    const persistentCounty = LocalStorageUtils.getLocalStorage(
      this.getCountyVariable()
    );

    const persistentRegion = LocalStorageUtils.getLocalStorage(
      this.getRegionVariable()
    );

    this.state = {
      data: [],
      imageData: "",
      startDate: persistentStartDate
        ? persistentStartDate
        : moment(QueueStartDate),
      endDate: persistentEndDate ? persistentEndDate : moment(),
      focusedInput: null,
      countyData: null,
      showDataEntry: false,
      selectedItemId: null,
      formIsReadOnly: false,
      currentCrashId: "",
      imagePopup: false,
      workflowItemStepId: null,
      cellData: null,
      rowData: null,
      transcriberData: [],
      jsonData: [],
      workflowItemStepWorkflowItemId: null,
      enableContinue: false,
      showTValForm: false,
      includeNewDriverReports: persistentIncludeNewDriverReports,
      showLRS: pendingLRSVariable,
      showLoadingNext: false,
      locationEntryDataToSave: null,
      locationEntryValidations: [],
      savingLocationData: false,

      selectedCounty: persistentCounty || "All",
      selectedRegion: persistentRegion || Districts.All,
      loadingWorkflowSteps: false,
      totalWorkflowItemSteps: 0,
      pagingCriteria: {
        itemsPerPage: 10,
        pageNumber: 1,
        searchCriteria: null,
        orderByField: "PriorityNumber",
        orderDescending: false
      }
    };

    if (this.state.countyData === null || this.state.countyData.length == 0)
      getTableValuesByGroupName("County").then((result) =>
        this.setState({ countyData: result })
      );
  }

  getIncludeNewDriverVariable = (): string => {
    return this.props.queueToShow == eLocationQueue.SpotMapping
      ? this.smIncludeNewDriverReportsVariable
      : this.lIncludeNewDriverReportsVariable;
  };

  getPendingLRSVariable = (): string => {
    return this.props.queueToShow == eLocationQueue.SpotMapping
      ? this.smPendingLRSVariable
      : this.lPendingLRSVariable;
  };

  getStartDateVariable = (): string => {
    return this.props.queueToShow == eLocationQueue.SpotMapping
      ? this.smStartDateVariable
      : this.lStartDateVariable;
  };

  getEndDateVariable = (): string => {
    return this.props.queueToShow == eLocationQueue.SpotMapping
      ? this.smEndDateVariable
      : this.lEndDateVariable;
  };

  getCountyVariable = (): string => {
    return this.props.queueToShow == eLocationQueue.SpotMapping
      ? this.smCountyVariable
      : this.lCountyVariable;
  };

  getRegionVariable = (): string => {
    return this.props.queueToShow == eLocationQueue.SpotMapping
      ? this.smRegionVariable
      : this.lRegionVariable;
  };

  handleIncludeNewDriverReports(includeNew: any) {
    LocalStorageUtils.setLocalStorageItem(
      this.getIncludeNewDriverVariable(),
      includeNew
    );
    this.setState(
      {
        includeNewDriverReports: includeNew
      },
      () => {
        this.doSearch();
      }
    );
  }

  handleCheckLRS(checked: any) {
    LocalStorageUtils.setLocalStorageItem(
      this.getPendingLRSVariable(),
      checked
    );
    this.setState(
      {
        showLRS: checked
      },
      () => {
        this.doSearch();
      }
    );
  }

  openReportToRead = (rowData: ISpotMappingQueueDetails) => {
    this.setState(
      {
        selectedItemId: rowData.workFlowItemStepId,
        showDataEntry: true,
        formIsReadOnly: true,
        cellData: rowData,
        rowData: rowData
      },
      () => {
        this.viewAllDocuments(rowData);
      }
    );
  };

  handleSetData = (rowData: ISpotMappingQueueDetails) => {
    const workflowItemStepId = rowData.workFlowItemStepId;
    if (rowData.assignedToId == this.props.currentUser.id) {
      this.setState({
        selectedItemId: workflowItemStepId,
        showDataEntry: true,
        formIsReadOnly: false,
        cellData: rowData,
        rowData: rowData
      });
    } else {
      this.props
        .assignWorkflowItem(
          urls.ASSIGN_WORKFLOW_ITEM_STEP,
          workflowItemStepId,
          this.props.currentUser.id
        )
        .then(() => {
          let allData = this.state.data;
          allData.find(
            (item) => item.workFlowItemStepId == workflowItemStepId
          ).assignedToId = this.props.currentUser.id;

          this.setState({
            selectedItemId: workflowItemStepId,
            showDataEntry: true,
            formIsReadOnly: false,
            data: allData,
            cellData: rowData,
            rowData: rowData
          });
        });
    }
    this.showImagePopup();
  };

  showImagePopup = () => {
    if (this.state.imageData && this.state.imageData.trim().length > 0) {
      const file = b64toBlob(
        this.state.imageData.replace("data:application/pdf;base64,", ""),
        "application/pdf"
      );

      const fileURL = URL.createObjectURL(file);

      if (this.state.imagePopup == false || this.currentImageWindow == null) {
        this.currentImageWindow = window.open(
          fileURL,
          "_blank",
          "width=800,height=500"
        );
        this.setState({ imagePopup: true });
      } else {
        this.currentImageWindow.location.href = fileURL;
      }
    }
  };

  viewAllDocuments(
    rowData: ISpotMappingQueueDetails
  ) {
    const url = `/DocumentViewer?r=${rowData.reportId}&dbToSearch=${"private"}`;
    window.open(url, '_blank', 'width=1300,height=900');
    this.handleSetData(rowData);
  }

  handleAssignAndOpen(rowData: ISpotMappingQueueDetails) {
    const workflowItemStepId = rowData.workFlowItemStepId;
    const workflowItemStepWorkflowItemId = rowData.workFlowItemId;
    // workflowItemStepWorkflowItemId is the workflow_item_id column on the workflow_item_steps table
    this.setState({
      workflowItemStepId: workflowItemStepId,
      workflowItemStepWorkflowItemId: workflowItemStepWorkflowItemId
    });

    this.getJsonData(workflowItemStepWorkflowItemId).then((res) => {
      this.viewAllDocuments(rowData);
    });
  }

  handleUnAssign(rowData: ISpotMappingQueueDetails) {
    Api.post(
      urls.UNASSIGN_WORKFLOW_ITEM_STEP_BY_ID,
      rowData.workFlowItemStepId
    ).then((response: ApiResponse<any>) => {
      if (response.ok) {
        let allData = this.state.data;
        allData.find(
          (item) => item.workFlowItemStepId == rowData.workFlowItemStepId
        ).assignedToId = null;
        this.setState({ data: allData });
      }
    });
  }

  handleCountyChange = (e) => {
    LocalStorageUtils.setLocalStorageItem(
      this.getCountyVariable(),
      e.target.value
    );
    this.setState({ selectedCounty: e.target.value }, () => {
      this.doSearch();
    });
  };

  handleDistrictChange = (e) => {
    LocalStorageUtils.setLocalStorageItem(
      this.getRegionVariable(),
      e.target.value
    );
    this.setState({ selectedRegion: Number(e.target.value) }, () => {
      this.doSearch();
    });
  };

  handleClose = () => {
    this.setState(
      {
        showDataEntry: false,
        selectedItemId: null,
        imagePopup: false,
        locationEntryValidations: []
      },
      () => {
        if (this.currentImageWindow) this.currentImageWindow.close();
      }
    );
  };

  componentDidMount() {
    this.doSearch();
  }

  doSearch() {
    this.setState({ loadingWorkflowSteps: true });

    let persistentIncludeNewDriverReports =
      LocalStorageUtils.getLocalStorageBool(
        this.getIncludeNewDriverVariable()
      ) || false;
    const pendingLRSVariable =
      LocalStorageUtils.getLocalStorageBool(this.getPendingLRSVariable()) ||
      false;
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.getStartDateVariable()
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.getEndDateVariable()
    );
    const persistentCounty = LocalStorageUtils.getLocalStorage(
      this.getCountyVariable()
    );

    const persistentRegion = LocalStorageUtils.getLocalStorage(
      this.getRegionVariable()
    );
    const request: GetReportsByQueueTypePagedRequest = {
      ...this.state.pagingCriteria,
      id:
        this.props.queueToShow == eLocationQueue.SpotMapping
          ? eWorkflowQueues.SpotMapping
          : eWorkflowQueues.LocationReview,
      includeNewDriverReports: persistentIncludeNewDriverReports
        ? persistentIncludeNewDriverReports
        : this.state.includeNewDriverReports,
      showLRS: pendingLRSVariable ? pendingLRSVariable : this.state.showLRS,
      startDate: persistentStartDate
        ? persistentStartDate.toDate()
        : this.state.startDate.toDate(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate()
        : this.state.endDate.toDate(),
      county: persistentCounty
        ? persistentCounty == "All"
          ? ""
          : persistentCounty
        : this.state.selectedCounty == "All"
          ? ""
          : this.state.selectedCounty,
      region: persistentRegion || this.state.selectedRegion
    };

    Api.post(urls.GET_REPORTS_BY_QUEUE_PAGED, request).then(
      (response: ApiResponse<IGetReportsByQueueTypePagedResponse>) => {
        if (response.ok) {
          this.setState({
            data: response.data.queueItems,
            totalWorkflowItemSteps: response.data.totalResults
          });
        }

        this.setState({ loadingWorkflowSteps: false });
      }
    );
  }

  getExportData = async (): Promise<ISpotMappingQueueDetails[]> => {
    let persistentIncludeNewDriverReports =
      LocalStorageUtils.getLocalStorageBool(
        this.getIncludeNewDriverVariable()
      ) || false;
    const pendingLRSVariable =
      LocalStorageUtils.getLocalStorageBool(this.getPendingLRSVariable()) ||
      false;
    const persistentStartDate = LocalStorageUtils.getLocalStorageDate(
      this.getStartDateVariable()
    );
    const persistentEndDate = LocalStorageUtils.getLocalStorageDate(
      this.getEndDateVariable()
    );
    const persistentCounty = LocalStorageUtils.getLocalStorage(
      this.getCountyVariable()
    );

    const persistentRegion = LocalStorageUtils.getLocalStorage(
      this.getRegionVariable()
    );

    const request: GetReportsByQueueTypePagedRequest = {
      ...this.state.pagingCriteria,
      itemsPerPage: this.state.totalWorkflowItemSteps,
      pageNumber: 1,
      id:
        this.props.queueToShow == eLocationQueue.SpotMapping
          ? eWorkflowQueues.SpotMapping
          : eWorkflowQueues.LocationReview,
      includeNewDriverReports: persistentIncludeNewDriverReports
        ? persistentIncludeNewDriverReports
        : this.state.includeNewDriverReports,
      showLRS: pendingLRSVariable ? pendingLRSVariable : this.state.showLRS,
      startDate: persistentStartDate
        ? persistentStartDate.toDate()
        : this.state.startDate.toDate(),
      endDate: persistentEndDate
        ? persistentEndDate.toDate()
        : this.state.endDate.toDate(),
      county: persistentCounty
        ? persistentCounty == "All"
          ? ""
          : persistentCounty
        : this.state.selectedCounty == "All"
          ? ""
          : this.state.selectedCounty,
      region: persistentRegion || this.state.selectedRegion
    };

    const response: ApiResponse<IGetReportsByQueueTypePagedResponse> =
      await Api.post(urls.GET_REPORTS_BY_QUEUE_PAGED, request);

    if (response.ok) {
      return response.data?.queueItems || [];
    }
    return [];
  };

  handleFocusChange = (focusedInput) => this.setState({ focusedInput });

  handleUpdateLocationData = (data: any) => {
    this.setState({ locationEntryDataToSave: data });
  };

  handleSave = () => {
    let allDataFromEntry = {
      data: this.state.locationEntryDataToSave,
      currentItemId: this.state.workflowItemStepId
    };
    const dataToSave = {
      spotMappedLocations: allDataFromEntry.data.spotMappedLocations,
      correctedData: allDataFromEntry.data.correctedData,
      workflowItemStepId: allDataFromEntry.currentItemId,
      currentUserId: this.props.currentUser.id,
      doComplete: false
    };

    Api.post(urls.SAVE_DATA_FOR_LOCATION_DATA_ENTRY, dataToSave).then(
      (response: ApiResponse<any>) => {
        if (response.ok && response.data.saved) {
          console.log("saved location data", { dataToSave });
        }
      }
    );
  };

  /**
   * Fixes an issue where the created data has 0000 as the year
   * which causes an exception server side
   */
  correctSmlCreatedDate(spotMappedLocations: Array<any>): Array<any> {
    const correctedSpotMappedLocations = spotMappedLocations.map(sml => {
      if (sml.createdDate && sml.createdDate.startsWith("0000")) {
        sml.createdDate = sml.createdDate.replace('0000', '0001');
      }
      if (sml.modifiedDate && sml.modifiedDate.startsWith("0000")) {
        sml.modifiedDate = sml.modifiedDate.replace('0000', '0001');
      }
      return sml;
    });

    return correctedSpotMappedLocations;
  }

  handleComplete = (resolve: any = null) => {
    this.setContinue(false);
    let allDataFromEntry = {
      data: this.state.locationEntryDataToSave,
      currentItemId: this.state.workflowItemStepId
    };

    allDataFromEntry.data.spotMappedLocations = this.correctSmlCreatedDate(allDataFromEntry.data.spotMappedLocations);

    let dataToSave = {
      spotMappedLocations: allDataFromEntry.data.spotMappedLocations,
      correctedData: allDataFromEntry.data.correctedData,
      workflowItemStepId: allDataFromEntry.currentItemId,
      currentUserId: this.props.currentUser.id,
      doComplete: true
    };

    this.setState({ savingLocationData: true });
    Api.post(urls.SAVE_DATA_FOR_LOCATION_DATA_ENTRY, dataToSave)
      .then((response: ApiResponse<any>) => {
        if (response.ok) {
          if (response.data.saved) {
            this.setState({
              data: this.state.data.filter(
                (item) =>
                  !(item.workFlowItemStepId == allDataFromEntry.currentItemId)
              ),
              selectedItemId: null,
              showDataEntry: false
            });
          } else if (
            response.data.validationErrors &&
            response.data.validationErrors.length > 0
          ) {
            this.setState({
              locationEntryValidations: response.data.validationErrors
            });
          }
        }
      })
      .finally(() => {
        this.setContinue(true);
        this.setState({ savingLocationData: false });
        if (typeof resolve === "function") {
          resolve();
        }
      });
  };

  handleCompleteAndAssignNext = () => {
    this.setState({
      showLoadingNext: true,
      showDataEntry: false
    });
    new Promise<void>(async (resolve, reject) => {
      this.handleComplete(resolve);
    })
      .then(() => {
        const nextReport =
          this.state.data.filter(r => r.assignedToId === null)[0]
        if (nextReport) {
          this.handleAssignAndOpen(nextReport);
          this.setContinue(false);
        }

        this.setState({ showLoadingNext: false });
      })
      .finally(() => {
        this.setState({ savingLocationData: false });
      });
  };

  sendToManagementQueue = () => {
    try {
      this.handleSave();
      Api.post(urls.SEND_TO_MANAGEMENT_QUEUE, {
        workflowItemStepId: this.state.selectedItemId
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          let currentData = this.state.data.filter(
            (item) => item.workFlowItemStepId != this.state.workflowItemStepId
          );
          this.setState({
            data: currentData,
            workflowItemStepId: null,
            showDataEntry: false
          });
        }
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };

  handleOpenInDataTranscriberValidation(
    event: React.MouseEvent<HTMLElement>,
    rowData: any,
    readonly?: any
  ) {
    event.preventDefault();
    this.openInDataTranscriberValidation(rowData, readonly);
  }

  getJsonData = async (workflowItemStepWorkflowItemId: number) => {
    const id = {
      id: workflowItemStepWorkflowItemId.toString()
    };

    await Api.post(
      urls.GET_REPORT_VALIDATION_JSON_FOR_LOCATION,
      JSON.stringify(id)
    ).then((response: ApiResponse<any>) => {
      this.setState({ jsonData: response.data });
      return response.data;
    });
  };

  openInDataTranscriberValidation = (rowData: any, readonly: any = false) => {
    let location: IAppRouteLocation = {
      pathname: "/DataTranscriberValidation",
      key: "absca"
    };

    let locationState: any = {};
    locationState.data = this.state.data;
    location.state = locationState;
    this.props.history.push(location, locationState);
  };

  componentWillUnmount() {
    this.handleClose();
  }

  setContinue = (yesNo: boolean) => {
    this.setState({ enableContinue: yesNo });
  };

  closeTValForm = () => {
    this.setState({ showTValForm: false });
  };

  showTValForm = () => {
    const url = "/ViewTval?WFSID=" + this.state.rowData.workFlowItemStepId;
    window.open(url, "_blank", "width=1300,height=900");
  };

  handlePagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ pagingCriteria: pagingCriteria as any }, () => {
      this.doSearch();
    });
  };

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      LocalStorageUtils.setLocalStorageItem(
        this.getStartDateVariable(),
        startDate
      );
      LocalStorageUtils.setLocalStorageItem(this.getEndDateVariable(), endDate);
      this.setState({ startDate, endDate }, () => {
        this.doSearch();
      });
    }
  }

  handleClearDateSelection = (): void => {
    LocalStorageUtils.removeLocalStorageItem(this.getStartDateVariable());
    LocalStorageUtils.removeLocalStorageItem(this.getEndDateVariable());
    this.setState(
      { startDate: moment(QueueStartDate), endDate: moment() },
      () => {
        this.doSearch();
      }
    );
  };

  spotMappingColumns: TableColumn<ISpotMappingQueueDetails>[] = [
    {
      name: "AVAILABLE ACTIONS",
      selector: (row) => row?.workFlowItemStepId,
      sortField: "Id",
      sortable: true,
      wrap: true,
      format: (row: ISpotMappingQueueDetails) => (
        <div className="buttonColumn">
          {(row.assignedToId == null ||
            row.assignedToId == this.props.currentUser.id) && (
              <Button
                variant="outline-primary"
                size="sm"
                onClick={(e) => this.handleAssignAndOpen(row)}
              >
                {row.assignedToId != null &&
                  row.assignedToId == this.props.currentUser.id
                  ? "Continue"
                  : "Start"}
              </Button>
            )}

          {row.assignedToId != null && (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={(e) => this.handleUnAssign(row)}
            >
              Unassign
            </Button>
          )}
          {'  '}
          <Provider store={reduxStore}>
            <CommentsButton
              reportId={row.reportId}
              className="btn-sm"
              placement="right"
              report={row.report} />
          </Provider>
        </div>
      )
    },
    {
      name: "CRASH KEY",
      sortField: "OriginalCrashKey",
      wrap: true,
      selector: (row) => row?.originalCrashKey || "",
      format: (row) => {
        return (
          <div>
            {row?.originalCrashKey || ""}
            <MergedIndicator
              supplementedReports={row.supplementedReports}
              reportsMergedToThis={row.reportsMergedToThis}
            />
            <CompletedIndicator
              completedDate={row.completedDate}
            />
          </div>
        );
      },
      sortable: true
    },
    {
      name: "COUNTY",
      sortField: "County",
      wrap: true,
      selector: (row) => row?.county || "",
      sortable: true
    },
    {
      name: "CITY",
      sortField: "City",
      wrap: true,
      selector: (row) => row?.city || "",
      sortable: true
    },
    {
      name: "ROUTE ID",
      sortField: "RouteId",
      wrap: true,
      selector: (row) => row?.routeId || "",
      sortable: true
    },
    {
      name: "REFERENCE POST",
      sortField: "ReferencePost",
      wrap: true,
      selector: (row) => row?.referencePost || "",
      sortable: true
    },
    {
      name: "STREETNAME",
      sortField: "PrimaryRoadway",
      wrap: true,
      selector: (row) => row?.primaryRoadway || "",
      sortable: true
    },
    {
      name: "CRASH DATE",
      sortable: true,
      sortField: "CrashDate",
      wrap: true,
      selector: (row) =>
        row?.crashDate ? moment(row.crashDate).format("MM/DD/YYYY") : ""
    },
    {
      name: "WORKFLOW STATUS",
      sortField: "Status",
      wrap: true,
      selector: (row) => row?.status || "Status Indeterminable",
      sortable: true
    },
    {
      name: "PRIORITY",
      sortField: "PriorityNumber",
      wrap: true,
      selector: (row) => row?.keywords?.priorityName || "",
      sortable: true
    }
  ];

  exportColumnMaps: IExportColumnMap[] = [
    { columnName: "ID", propertyName: "workFlowItemStepId" },
    { columnName: "CRASH KEY", propertyName: "originalCrashKey" },
    { columnName: "COUNTY", propertyName: "county" },
    { columnName: "CITY", propertyName: "city" },
    { columnName: "ROUTE ID", propertyName: "routeId" },
    { columnName: "REFERENCE POST", propertyName: "referencePost" },
    { columnName: "STREET NAME", propertyName: "primaryRoadway" },
    {
      columnName: "CRASH DATE",
      propertyName: "crashDate",
      convertMethod: (val) => moment(val).format("MM/DD/YYYY")
    },
    { columnName: "WORKFLOW STATUS", propertyName: "status" },
    { columnName: "PRIORITY", propertyName: "priorityName" }
  ];

  locationReviewColumns: TableColumn<ISpotMappingQueueDetails>[] = [
    {
      name: "AVAILABLE ACTIONS",
      selector: (row) => row?.workFlowItemStepId,
      sortField: "Id",
      sortable: true,
      wrap: true,
      format: (rowData: ISpotMappingQueueDetails) => {
        return (
          <div className="buttonColumn">
            {(rowData.assignedToId == null ||
              rowData.assignedToId == this.props.currentUser.id) && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={(e) => this.handleAssignAndOpen(rowData)}
                >
                  {rowData.assignedToId != null &&
                    rowData.assignedToId == this.props.currentUser.id
                    ? "Continue"
                    : "Start"}
                </Button>
              )}
            {'  '}
            <Provider store={reduxStore}>
              <CommentsButton
                reportId={rowData.reportId}
                className="btn-sm"
                placement="right"
                report={rowData.report} />
            </Provider>

            {rowData.assignedToId != null && (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={(e) => this.handleUnAssign(rowData)}
              >
                Unassign
              </Button>
            )}
            
          
          </div>
        );
      }
    },
    {
      name: "CRASH KEY",
      sortField: "OriginalCrashKey",
      wrap: true,
      selector: (row) => row?.originalCrashKey || "",
      format: (row) => {
        return (
          <div>
            {row?.originalCrashKey || ""}
            <MergedIndicator
              supplementedReports={row.supplementedReports}
              reportsMergedToThis={row.reportsMergedToThis}
            />
            <CompletedIndicator
              completedDate={row.completedDate}
            />
            <DriverReportMergedIndicator
              hasMergedDriverReport={row.hasMergedDriverReport}
            />
          </div>
        );
      },
      sortable: true
    },
    {
      name: "COUNTY",
      sortField: "County",
      wrap: true,
      selector: (row) => row?.county || "",
      sortable: true
    },
    {
      name: "CITY",
      sortField: "City",
      wrap: true,
      selector: (row) => row?.city || "",
      sortable: true
    },
    {
      name: "ROUTE ID",
      sortField: "RouteId",
      wrap: true,
      selector: (row) => row?.routeId || "",
      sortable: true
    },
    {
      name: "REFERENCE POST",
      sortField: "ReferencePost",
      wrap: true,
      selector: (row) => row?.referencePost || "",
      sortable: true
    },
    {
      name: "STREETNAME",
      sortField: "PrimaryRoadway",
      wrap: true,
      selector: (row) => row?.primaryRoadway || "",
      sortable: true
    },
    {
      name: "CRASH DATE",
      sortable: true,
      sortField: "CrashDate",
      wrap: true,
      selector: (row) =>
        row?.crashDate ? moment(row.crashDate).format("MM/DD/YYYY") : ""
    },
    {
      name: "WORKFLOW STATUS",
      sortField: "Status",
      wrap: true,
      selector: (row) => row?.status || "Status Indeterminable",
      sortable: true
    },
    {
      name: "PRIORITY",
      sortField: "PriorityNumber",
      wrap: true,
      selector: (row) => row?.keywords?.priorityName || "",
      sortable: true
    }
  ];

  locationQueueOptions: IDataTableOptionalProps = {
    info: true,
    showSelectInfo: false,
    lengthChange: false,
    select: false,
    dom: "tipB",
    orderFixed: {
      pre: [11, "asc"]
    },
    autoWidth: false
  };

  render() {
    let counties = this.state.countyData;

    if (counties != null && counties.findIndex((a) => a.name == "All") < 0)
      counties.unshift({ name: "All", description: "All" });
    return (
      <React.Fragment>
        <h4>
          {this.props.queueToShow == eLocationQueue.SpotMapping
            ? "Location Mapping"
            : "Location Review"}
        </h4>

        <Container
          style={{
            marginTop: "15px",
            marginBottom: "10px",
            maxWidth: "100%",
            paddingLeft: "0px"
          }}
        >
          <Row>
            <Col>
              <DateRangePicker
                minimumNights={0}
                endDateId="endDate"
                focusedInput={this.state.focusedInput}
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                }
                onFocusChange={this.handleFocusChange}
                startDate={
                  LocalStorageUtils.getLocalStorageDate(
                    this.getStartDateVariable()
                  ) || this.state.startDate
                }
                endDate={
                  LocalStorageUtils.getLocalStorageDate(
                    this.getEndDateVariable()
                  ) || this.state.endDate
                }
                startDateId="startDate"
                showDefaultInputIcon={true}
                inputIconPosition={"after"}
                small={true}
                isOutsideRange={() => false}
              />
              {(LocalStorageUtils.getLocalStorageDate(
                this.getStartDateVariable()
              ) ||
                LocalStorageUtils.getLocalStorageDate(
                  this.getEndDateVariable()
                )) && (
                  <button
                    className="btn btn-outline-danger btn-sm"
                    style={{ fontSize: "14px", marginLeft: "5px" }}
                    title="Clear Date Filter"
                    onClick={this.handleClearDateSelection}
                  >
                    <i className="fa fa-calendar-xmark" />
                  </button>
                )}
            </Col>
            <Col>
              <Row>
                <Col>
                  <Form.Group controlId="NewDriver">
                    <Form.Check
                      type="checkbox"
                      label=" Held Driver Reports"
                      checked={LocalStorageUtils.getLocalStorageBool(
                        this.getIncludeNewDriverVariable()
                      )}
                      onChange={(e) =>
                        this.handleIncludeNewDriverReports(e.target.checked)
                      }
                    />
                  </Form.Group>
                </Col>
                {this.props.queueToShow != eLocationQueue.SpotMapping &&
                  hasPermission(this.props.currentUser, "View Pending LRS") && (
                    <Col>
                      <Form.Group controlId="LRS">
                        <Form.Check
                          type="checkbox"
                          label=" Pending LRS"
                          checked={LocalStorageUtils.getLocalStorageBool(
                            this.getPendingLRSVariable()
                          )}
                          onChange={(e) =>
                            this.handleCheckLRS(e.target.checked)
                          }
                        />
                      </Form.Group>
                    </Col>
                  )}
              </Row>
            </Col>
            <Col xs={5}
              style={{
                textAlign: "right",
                paddingRight: "0px"
              }}
            >
              {this.state.countyData != null && (
                <React.Fragment>
                  <span
                    style={{
                      fontVariant: "small-caps",
                      fontWeight: 700,
                      fontSize: "large"
                    }}
                  >
                    county:{" "}
                  </span>
                  <select
                    className="selQueueFilter"
                    value={
                      LocalStorageUtils.getLocalStorage(
                        this.getCountyVariable()
                      ) || this.state.selectedCounty
                    }
                    onChange={this.handleCountyChange}
                    style={{ marginRight: "15px" }}
                  >
                    {counties.map((item, idx) => {
                      return (
                        <option key={idx} value={item.description}>
                          {item.description}
                        </option>
                      );
                    })}
                  </select>
                </React.Fragment>
              )}
              <span
                style={{
                  fontVariant: "small-caps",
                  fontWeight: 700,
                  fontSize: "large"
                }}
              >
                region:{" "}
              </span>
              <select
                className="selQueueFilter"
                value={
                  LocalStorageUtils.getLocalStorage(this.getRegionVariable()) ||
                  this.state.selectedRegion
                }
                style={{ width: "150px" }}
                onChange={this.handleDistrictChange}
              >
                {["All", 1, 2, 3, 4, 5, 6].map((item, idx) => {
                  return (
                    <option
                      key={idx}
                      value={typeof item == "string" ? Districts[item] : item}
                    >
                      {item}
                    </option>
                  );
                })}
              </select>
            </Col>
          </Row>
        </Container>
        <PagedDatatable
          {...this.locationQueueOptions}
          columns={
            this.props.queueToShow == eLocationQueue.SpotMapping
              ? this.spotMappingColumns
              : this.locationReviewColumns
          }
          data={this.state.data || []}
          loadingData={this.state.loadingWorkflowSteps}
          totalDataItems={this.state.totalWorkflowItemSteps}
          exportTitle={
            this.props.queueToShow == eLocationQueue.SpotMapping
              ? "Spot Mapping Queue"
              : "Location Review Queue"
          }
          exportFileName={
            this.props.queueToShow == eLocationQueue.SpotMapping
              ? "SpotMappingQueue"
              : "LocationReviewQueue"
          }
          exportColumnMaps={this.exportColumnMaps}
          pagingCriteria={this.state.pagingCriteria}
          updatePagedResults={this.handlePagingCriteriaChange}
          getExportData={this.getExportData}
        ></PagedDatatable>
        <Modal
          show={this.state.showDataEntry}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          size="xl"
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <div style={{ width: "100%" }}>
              <Row>
                <Col>
                  <b>
                    Location{" "}
                    {this.props.queueToShow == eLocationQueue.SpotMapping
                      ? "Mapping Entry"
                      : "Review"}
                  </b>
                </Col>
                <Col>
                  <Button variant="info" onClick={() => this.showTValForm()}>
                    View Transcriber Validation Form
                  </Button>
                </Col>
                <Col>
                  <span style={{ float: "right" }}>
                    <b>Crash Key</b>&nbsp;{" "}
                    {this.state.rowData && this.state.rowData.originalCrashKey}
                  </span>
                </Col>
              </Row>
            </div>
          </Modal.Header>
          <Modal.Body>
            <LocationEntry
              ref={(comp) => {
                this.dataEntry = comp;
              }}
              currentQueueType={
                this.props.queueToShow == eLocationQueue.SpotMapping
                  ? LocationWorkflowStepName.SpotMapping
                  : LocationWorkflowStepName.Review
              }
              setCrashId={(id) => this.setState({ currentCrashId: id })}
              itemToEdit={this.state.selectedItemId}
              webserviceUrl={this.props.endPoint.replace("/api/", "")}
              readOnly={this.state.formIsReadOnly}
              currentUserId={this.props.currentUser.id}
              userTypeId={
                this.props.queueToShow == eLocationQueue.SpotMapping ? 2 : 3
              }
              setContinue={this.setContinue}
              workflowItemStepId={this.state.workflowItemStepId}
              updateDataToSave={this.handleUpdateLocationData}
              validationErrors={this.state.locationEntryValidations}
            />
          </Modal.Body>
          <Modal.Footer>
            {this.state.savingLocationData && (
              <div>
                Saving {"   "}
                <img
                  src={require("../../../../../src/assets/SmartAdmin/img/32/Marty.gif")}
                />
              </div>
            )}
            {!this.state.savingLocationData && (
              <React.Fragment>
                <Button
                  variant="secondary"
                  onClick={() => this.sendToManagementQueue()}
                >
                  Send to Management
                </Button>
                <Button
                  variant="primary"
                  onClick={() => this.handleComplete()}
                  disabled={!this.state.enableContinue}
                >
                  Complete
                </Button>
                <Button
                  variant="success"
                  onClick={() => this.handleCompleteAndAssignNext()}
                  disabled={!this.state.enableContinue}
                >
                  Complete and Assign Next
                </Button>
              </React.Fragment>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showLoadingNext}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <ModalBody>
            <h4
              style={{
                textAlign: "center",
                padding: "10px",
                fontVariant: "all-small-caps"
              }}
            >
              Loading
            </h4>
            <ProgressBar
              animated
              now={100}
              style={{ margin: "0 auto", marginBottom: "25px" }}
            />
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}
